// NOTES
//-------------------------------------------------------------------------------------------------------------------------
// We are attempting to stop using DELETE, PATCH, and BATCH.  When writing client side methods, try to call into GET or POST
// and not these others

// Also, moving forward, we want to stop using specific, named functions here to do webservice calls.  Almost all calls can
// be done by useing Get or Post above inside the client area that needs to communicate with the server.



// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';
//import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';

//Token
import { authToken } from '../authToken';

//App config
import { appConfig } from '../../shared/appConfig.js';

//Services
import { Helpers } from '../../shared/services/helpers';



// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// WebServices
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// This is a generic derivative of ApiService for straight web service calls with no need for any additional logic.
@Injectable()
export class WebServices {

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _cache = {};

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor( http:HttpClient, helpers: Helpers ){
        this.constructor.mapParams( this, arguments );
    }


    // GETTERS/SETTERS
    //-------------------------------------------------------------------------------------------------------------------------


    // GENERAL (REST) WEBSERVICE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // DownloadCsv
    //==================================
    //  apiPath<string>                 //(req)
    //  selection<string>               //(opt)
    //  filter<object> = {              //(opt)
    //      ...<custom>                 //Each endpoint may have additional parameters it requires.  Those are placed here.
    DownloadCsv(options){

        //Validate params
        if (!options || !options.apiPath){ throw("[webServices:DownloadCsv()] options & options.apiPath required"); };

        //Defaults
        options.filter = options.filter || {};
        options.filter.asCsv = true;

        //Get the formatted url
        let formattedUrl = this._formatUrl(options.apiPath, options.selection, options.filter);

        //Stevie's fun house
        let req = new XMLHttpRequest();
        req.open("GET", formattedUrl, true);
        req.setRequestHeader( "token", authToken.token );
        req.responseType = "blob";
        req.onload = (event) => {
            let fileName = req.getResponseHeader("Content-Disposition").split("filename=")[1];
            if( window.navigator.msSaveOrOpenBlob ){
                window.navigator.msSaveOrOpenBlob(req.response, fileName);
            }
            else{
                let link=document.createElement('a');
                link.href=window.URL.createObjectURL(req.response);
                link.download=fileName;
                link.click();
            }
            
        };

        req.send();
    }

    //==================================
    // Get
    //==================================
    //options = {                       //(req)
    //  apiPath<string>                 //(req)
    //  cache<bool>                     //(opt, false)
    //  clone<bool>                     //(opt, false) If true a clone of the data is returned (ignored if cache is false as the data is a one-shot anyway)
    //  selection<string>               //(opt)
    //  filter<object> = {              //(opt) //This is an older mechanism and works fine for passing objects (use args if the method just has a list of args)
    //      limit<int>
    //      page<int>
    //      ...<custom>                 //Each endpoint may have additional parameters it requires.  Those are placed here.
    //  args<object>                    //Standard html args: ?prop1=123&etc=... DO NOT USE BOTH FILTER AND ARGS
    //  }
    Get(options){

        //Validate params
        if (!options || !options.apiPath){ throw("[webServices:Get()] options & options.apiPath required"); };

        //Default parameters
        options.cache = options.cache === undefined ? false : !!options.cache;
        options.clone = options.clone === undefined ? false : !!options.clone;
        options.selection = options.selection || null;
        options.filter = options.filter || null;

        options.args = options.args || null;

        if (options.filter && options.args) { throw ("[webServices:Get()] Cannot use filter AND args at the same time"); }

        //The formatted url also servers as a cache key if applicable
        let formattedUrl = this._formatUrl(options.apiPath, options.selection, options.filter, options.args);

        return new Promise( (resolve, reject) => {
            $.ajax(formattedUrl, {
                headers: this._buildHeaders(),
                method: "GET",
                complete: (xhr) => {

                    // Error
                    //-------------
                    if( xhr.status !== 200 ){
                        if (xhr.responseJSON){
                            reject(xhr.responseJSON);
                        }
                        else{
                            if (xhr.responseText){
                                reject(xhr.responseText);
                            }
                            else{
                                console.log("[WebServices:Get()] Unexcpected XHR Error - xhr.status:", xhr.status);
                                reject("[WebServices:Get()] Unexpected XHR error with no response.");
                            }
                        }
                    }

                    // Success
                    //-------------
                    else {
                        let xhrData = { data:xhr.responseJSON.data || xhr.responseJSON };

                        //Cache?
                        if (options.cache){
                            this._cache[formattedUrl] = xhrData;
                        }

                        //Clone?
                        if (options.cache && options.clone){
                            //Clone
                            resolve ( JSON.parse(JSON.stringify(xhrData)) );
                        }
                        else{
                            //No Clone
                            resolve(xhrData);
                        }
                    }
                } 
            });
        });
        
    };

    //==================================
    // GetCached
    //==================================
    // If the data is not found in the cache, a normal Get() will be executed with caching enabled
    // by default.
    //
    //options = {                       //(req)
    //  apiPath<string>                 //(req)
    //  cache<bool>                     //(opt, true) If true, and data is not yet cached, it will be retrieved and cached
    //  clone<bool>                     //(opt, false) If true, a clone of the data is returned
    //  selection<string>               //(opt)
    //  filter<object> = {              //(opt)
    //      limit<int>
    //      page<int>
    //      ...<custom>                 //Each endpoint may have additional parameters it requires.  Those are placed here.
    //  }
    GetCached(options){
      
        //Default parameters
        options.cache = options.cache === undefined ? true: !!options.cache;
        options.clone = options.clone === undefined ? false : !!options.clone;

        //formattedUrl is also the cache key
        let formattedUrl = this._formatUrl(options.apiPath, options.selection, options.filter);

        //Gotta send back a promise
        return new Promise((resolve, reject) => {

            //In cache?
            if (this._cache[formattedUrl]){
                
                //Clone?
                if (options.clone){
                    //Clone (This will not copy functions and might poop itself if there are circular references but I don't expect an of those for CPDES data coming from the server)
                    resolve( JSON.parse(JSON.stringify(this._cache[formattedUrl])) );
                }
                else{
                    //No clone
                    resolve(this._cache[formattedUrl]);
                }
            }
            else{

                //Not in cache, load the data from the server
                resolve( this.Get(options) );
            }
        });
    };

    //==================================
    // Patch
    //==================================
    // apiPath<string>      //(req)
    // id<num/str>          //(req)
    // data<any>            //Data to used to generate the original item in the service.
    Patch(apiPath, id, data){

        //Validate
        if (!apiPath){ throw("[webServices:Patch()] apiPath required"); };
        if (!id){ throw("[webServices:Patch()] id required"); };    //Assuming id is never going to be 0

        //Get the proper url for a patch
        var url = this._formatUrl(apiPath) + "/" + id;

        return new Promise( ( resolve, reject ) => {
            $.ajax( url, {
                headers : this._buildHeaders(),
                method : "PATCH",
                data : JSON.stringify( data ),
                complete : ( xhr ) => {
                    if( xhr.status !== 200 ){

                        if (xhr.responseJSON){
                            reject(xhr.responseJSON);
                        }
                        else{
                            if (xhr.responseText){
                                reject(xhr.responseText);
                            }
                            else{
                                console.log("[webServices:Patch()] Unexcpected XHR Error - xhr.status:", xhr.status);
                                reject("[webServices:Patch()] Unexpected XHR error with no response.");
                            }
                        }

                    }
                    else{
                        resolve( xhr.responseJSON );
                    }
                }
            } );
        } );
    }

    //==================================
    // Delete
    //==================================
    // apiPath<string>      //(req)
    // id<num/str>          //(req)
    // data<any>            //Data to used to generate the original item in the service.
    Delete(apiPath, id, data = {}){

        //Validate
        if (!apiPath){ throw("[webServices:Delete()] apiPath required"); };
        if (!id){ throw("[webServices:Delete()] id required"); };    //Assuming id is never going to be 0

        //Get the proper url for a patch
        var url = this._formatUrl(apiPath) + "/" + id;

        return new Promise( ( resolve, reject ) => {
            $.ajax( url, {
                headers : this._buildHeaders(),
                method : "DELETE",
                data : JSON.stringify( data ),
                complete : ( xhr ) => {
                    if( xhr.status !== 200 ){

                        if (xhr.responseJSON){
                            reject(xhr.responseJSON.error);
                        }
                        else{
                            if (xhr.responseText){
                                reject(xhr.responseText);
                            }
                            else{
                                console.log("[webServices:Delete()] Unexcpected XHR Error - xhr.status:", xhr.status);
                                reject("[webServices:Delete()] Unexpected XHR error with no response.");
                            }
                        }

                    }
                    else{
                        resolve( xhr.responseJSON );
                    }
                }
            } );
        } );
    }

    //==================================
    // Batch
    //==================================
    Batch(apiPath, data = {}) {

        return new Promise( ( resolve, reject ) => {
            $.ajax( this._formatUrl(apiPath), {
                headers : this._buildHeaders(),
                method : "BATCH",
                data : JSON.stringify( data ),
                complete : ( xhr ) => {
                    if( xhr.status !== 200 ){

                        if (xhr.responseJSON){
                            reject(xhr.responseJSON.error);
                        }
                        else{
                            if (xhr.responseText){
                                reject(xhr.responseText);
                            }
                            else{
                                console.log("[webServices:Patch()] Unexcpected XHR Error - xhr.status:", xhr.status);
                                reject("[webServices:Patch()] Unexpected XHR error with no response.");
                            }
                        }

                    }
                    else{
                        resolve( xhr.responseJSON );
                    }
                }
            } );
        } );
    }

    //==================================
    // Post
    //==================================
    // apiPath<string>      //(req)
    // data<any>            //Data to used to generate the original item in the service.
    Post(apiPath, data){

        //Validate
        if (!apiPath){ throw("[webServices:Post()] apiPath required"); };

        //Get the proper url for a post
        var url = this._formatUrl(apiPath);
        
        return new Promise( ( resolve, reject ) => {
            $.ajax( url, {
                headers: this._buildHeaders(),
                method : "POST",
                data : JSON.stringify( data ),
                complete : ( xhr ) => {
                    if( xhr.status !== 200 ){

                        if (xhr.responseJSON){
                            reject(xhr.responseJSON);
                        }
                        else{
                            if (xhr.responseText){
                                reject(xhr.responseText);
                            }
                            else{
                                console.log("[WebServices:Post()] Unexcpected XHR Error - xhr.status:", xhr.status);
                                reject("[WebServices:Post()] Unexpected XHR error with no response.");
                            }
                        }

                    }
                    else{
                        resolve( xhr.responseJSON );
                    }
                }
            } );
        } );
    }


    // FORMS-FIELDS WEBSERVICE FUNCTIONS (CPDES DB)
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // GetMyForm
    //==================================
    GetMyForm(formName){

        //Check params
        if (!formName){ 
            throw("[webServices:GetMyForm()] missing argument: formName"); 
        }

        var url = this._getApiServicePath() + "/cpdes/getMyForm";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ formName:formName },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });
    };

    //==================================
    // GetNavForms
    //==================================
    GetNavForms(){

        var url = this._getApiServicePath() + "/cpdes/getNavForms";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:null,
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });
    };


    // CPD MANAGEMENT WEBSERVICE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // GetDMSDocuments
    //==================================
    // practiceCode<string> (opt)
    GetDMSDocuments(practiceCode){

        //Business didn't want this filter.  Leaving the code in place and just disabling it for now.
        //practiceCode = "";

        var url = this._getApiServicePath() + "/cpdm/getDMSDocuments";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ practiceCode:practiceCode || "" },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });
    };
    
    //==================================
    // GetDMSPurposes
    //==================================
    GetDMSPurposes(batchId){

        var url = this._getApiServicePath() + "/cpdm/getDMSPurposes";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ batchId:batchId },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });
    };

    //==================================
    // GetDMSTransactions
    //==================================
    GetDMSTransactions(dateFilters){

        var url = this._getApiServicePath() + "/cpdm/getDMSTransactions";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:dateFilters,
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });
    };

    ////==================================
    //// SubmitDMSPractice
    ////==================================
    //SubmitDMSPractice(id){

    //    //This post works a bit different than the others.  It just needs to pass in a simple
    //    //int, so I'm passing it in as a route parameter.  Checkout the MVC endpoint to
    //    //see what I mean.
    //    var url = this._getApiServicePath() + "/cpdm/submitDMSPractice/";

    //    //Add our post parameter
    //    url += id;

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers: { 'token':authToken.token },
    //            method:"POST",
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });
    //};




    ////==================================
    //// GetResourceConcernCategories
    ////==================================
    //GetResourceConcernCategories(fiscalYear){

    //    var url = this._getApiServicePath() + "/cppe/getResourceConcernCategories";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"GET",
    //            data:{fiscalYear:fiscalYear},
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });
    //};





    // PRACTICES WEBSERVICE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //BASECAMP-862
    ////==================================
    //// DeletePractice
    ////==================================
    //DeletePractice(practiceId, endDate){

    //    var url = this._getApiServicePath() + "/practices/deletePractice/";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"POST",
    //            data:JSON.stringify({ practiceId:practiceId, endDate:endDate }),
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });        

    //};

    //==================================
    // GetPractice
    //==================================
    GetPractice(practiceId){

        var url = this._getApiServicePath() + "/practices/getPractice";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ practiceId:practiceId },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };

    ////==================================
    //// GetPracticesListByRole
    ////==================================
    //GetPracticesListByRole(filter){

    //    var url = this._getApiServicePath() + "/practices/getPracticesListByRole";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"GET",
    //            data:{ filter:filter },
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });        
    //};

    //==================================
    // GetPracticeState
    //==================================
    GetPracticeState(practiceStateId){

        var url = this._getApiServicePath() + "/practices/getPracticeState";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ practiceStateId:practiceStateId },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };
    
    //==================================
    // DV1_GetPublicPracticesList
    //==================================
    //  stateCountyCode<str>:       //(opt, null) Omit for a national list
    DV1_GetPublicPracticesList(stateCountyCode){

        stateCountyCode = stateCountyCode || null;

        var url = this._getApiServicePath() + "/practices/dv1_GetPublicPracticesList";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ stateCountyCode:stateCountyCode },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };


    ////==================================
    //// InsertPractice
    ////==================================
    //InsertPractice(newPractice){

    //    var url = this._getApiServicePath() + "/practices/insertNewPractice";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"POST",
    //            data:JSON.stringify(newPractice),
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });        
    //};

    //==================================
    // UpdatePractice
    //==================================
    //UpdatePractice(newPractice){

    //    var url = this._getApiServicePath() + "/practices/updatePractice";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"POST",
    //            data:JSON.stringify(newPractice),
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });        
    //};


    //==================================
    // ZRolesTest
    //==================================
    ZRolesTest(){

        //This function is intended to be used to trigger a debgging session on the server side (in local)
        //for testing zRoles.  It returns nothing meaningful.
        var url = this._getApiServicePath() + "/practices/zRolesTest";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET" ,
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };

    // PRACTICE PURPOSE WEBSERVICE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // AdoptNationalPurposes
    //==================================
    AdoptNationalPurposes(practiceStateId){

        var url = this._getApiServicePath() + "/practicePurpose/adoptNationalPurposes";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers: { 'token':authToken.token }, //Don't use the BuildHeaders function, as it sets content type
                method:"POST",
                data:{practiceStateId:practiceStateId},
                contentType:"application/x-www-form-urlencoded; charset=UTF-8", 
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };

    //==================================
    // ExportPPRCReport
    //==================================
    ExportPPRCReport(practiceStateId){

        var url = this._getApiServicePath() + "/practicePurpose/exportPPRCReport";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ practiceStateId:practiceStateId },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });

    };

    //==================================================
    // GetPracticePurposeResourceConcernComponents
    //==================================================
    GetPracticePurposeResourceConcernComponents(practicePurposeId){

        var url = this._getApiServicePath() + "/practicePurpose/getPracticePurposeResourceConcernComponents";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ practicePurposeId : practicePurposeId },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };
    
    //==================================
    // GetPracticePurposesByRole
    //==================================
    GetPracticePurposesByRole(practiceStateId){

        var url = this._getApiServicePath() + "/practicePurpose/getPracticesPurposesByRole";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                data:{ practiceStateId : practiceStateId },
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };

    //==================================
    // UpdatePracticePurpose
    //==================================
    // Updates limited info about a practice purpose and updates its resource concerns list
    UpdatePracticePurpose(data){

        var url = this._getApiServicePath() + "/practicePurpose/updatePracticePurpose";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"POST",
                data: JSON.stringify(data),
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };


    // PUBLICAPI WEBSERVICE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // InsertDMSTransaction
    //==================================
    // This function is here to make it easier to test this public api
    InsertDMSTransaction(strXML){
        
        var url = this._getApiServicePath() + "/publicapi/insertDMSTransaction";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                method : "POST",
                data : {xml:strXML},
                
                success: (data, status, xhr) => {
                    resolve(xhr.responseJSON);
                },

                error: (xhr, status, err) => {            
                    reject({err:err, status:xhr.status});
                }
            });
        });

        //Sample Expected XML
        /*
        <standard>
	        <practice_code>362</practice_code>
	        <state_county_code>00000</state_county_code>
	        <language_code>en</language_code>
	        <national_standard_release_date>2017-08-25Z</national_standard_release_date>
	        <national_standard_end_date/>
	        <state_standard_adoption_date/>
	        <state_standard_end_date/>
	        <practice_name>Diversion</practice_name>
	        <practice_unit>1</practice_unit>
	        <practice_definition> A channel generally constructed across the slope with a supporting ridge on the lower side. </practice_definition>
	        <installed_practice_lifespan>12</installed_practice_lifespan>
	        <practice_purposes>
		        <practice_purpose_name id="1"> Break up concentrations of water on long slopes, on undulating land surfaces and on land that is generally considered too flat or irregular for terracing.</practice_purpose_name>
		        <practice_purpose_name id="2"> Divert water away from farmsteads, agricultural waste systems, and other improvements.</practice_purpose_name>
		        <practice_purpose_name id="3"> Collect or direct water for storage, water-spreading, or water-harvesting systems.</practice_purpose_name>
		        <practice_purpose_name id="4"> Protect terrace systems by diverting water from the top terrace where topography, land use, or land ownership prevents terracing the land above.</practice_purpose_name>
		        <practice_purpose_name id="5"> Intercept surface and shallow subsurface flow.</practice_purpose_name>
		        <practice_purpose_name id="6"> Reduce runoff damages from upland runoff. </practice_purpose_name>
		        <practice_purpose_name id="7"> Reduce erosion and runoff on urban or developing areas and at construction or mining sites. </practice_purpose_name>
		        <practice_purpose_name id="8"> Divert water away from active gullies or critically eroding areas. </practice_purpose_name>
		        <practice_purpose_name id="9"> Supplement water management on conservation cropping or stripcropping systems. </practice_purpose_name>
	        </practice_purposes>
	        <practice_document_type>1</practice_document_type>
	        <practice_document_path>http://ecm-dev.nrcs.usda.gov/workspace</practice_document_path>
	        <practice_purpose_effective_date>12/12/2017 08:42:02</practice_purpose_effective_date>
	        <transaction_date>12/12/2017 08:42:02</transaction_date>
        </standard>
        */
    };
    
    //==================================
    // PublicAPI_Ping
    //==================================
    PublicAPI_Ping(str){
        
        var url = this._getApiServicePath() + "/publicapi/ping";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                method : "GET",
                data : {msg:str},
                
                success: (data, status, xhr) => {
                    resolve(xhr.responseJSON);
                },

                error: (xhr, status, err) => {            
                    reject({err:err, status:xhr.status});
                }
            });
        });
    };


    // RESOURCE CONCERN WEBSERVICE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    ////=========================================
    //// GetResourceConcernComponentsBySwappa
    ////=========================================
    //GetResourceConcernComponentsBySwappa(swapa_category_id){

    //    var url = this._getApiServicePath() + "/resource/getResourceConcernComponentsBySwappa";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"GET",
    //            data:{swapa_category_id:swapa_category_id},
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });        
    //};

    ////==================================
    //// GetResourceConcernCategories
    ////==================================
    //GetResourceConcernCategories(){

    //    var url = this._getApiServicePath() + "/resource/getResourceConcernCategories";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"GET",
    //            //data:{swapa_category_id:swapa_category_id},
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });        
    //};

    //==================================
    // GetSwapaGroupList
    //==================================
    GetSwapaGroupList(){

        var url = this._getApiServicePath() + "/resource/getSwapaGroupList";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"GET",
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });        
    };

    //==================================
    // SaveResourceConcern
    //==================================
    SaveResourceConcern(resourceDto){

        var url = this._getApiServicePath() + "/resource/saveResourceConcern";

        return new Promise((resolve, reject) => {

            $.ajax( url, {
                headers:this._buildHeaders(),
                method:"POST",
                data: JSON.stringify(resourceDto),
                success:(data, status, xhr) => { resolve(xhr.responseJSON); },
                error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
            });
        });
    };

    ////==================================
    //// SaveSwapa
    ////==================================
    //SaveSwapa(swapaDto){

    //    var url = this._getApiServicePath() + "/resource/saveSwapa";

    //    return new Promise((resolve, reject) => {

    //        $.ajax( url, {
    //            headers:this._buildHeaders(),
    //            method:"POST",
    //            data: JSON.stringify(swapaDto),
    //            success:(data, status, xhr) => { resolve(xhr.responseJSON); },
    //            error:(xhr, status, err) => { reject({err:err, status:xhr.status}); }
    //        });
    //    });
    //};


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // buildHeaders
    //==================================
    _buildHeaders(contentType) {
        contentType = contentType || "application/json"

        return {
            'Content-Type': contentType,
            'token' : authToken.token
        }
    };

    //==================================
    // _formatUrl
    //==================================
    _formatUrl(apiPath, selection, filter, args){

        if (filter && args) { throw ("[webServices:_formatUrl()] Cannot use filter AND args at the same time"); }

        let url = $("base").attr("api-service");
        url += selection ? (apiPath + "/" + selection) : apiPath;

        //Encode in any filters provided
        if (filter){
            url += "?" + encodeURIComponent(JSON.stringify(filter));
        }

        if (args) {
            url += "?" + Object.keys(args).map((k, i) => { return encodeURIComponent(k) + '=' + encodeURIComponent(args[k]) }).join("&");
        }

        //debugging
        //console.log("[" + apiPath + "]:");
        //console.log('  $("base")', $("base"));
        //console.log('  $("base").attr("api-service")', $("base").attr("api-service"));
        //console.log("  url:", url);
        //debugging

        return url;
    };

    //==================================
    // _getApiServicePath
    //==================================
    _getApiServicePath(){
        return $("base").attr("api-service");
    }

}//class




/*
// CALL EXAMPLES
//-------------------

    Standard GET
    =================
    this.webServices.Get({
        apiPath: "/endpoint/path", //omit "api"
        args: {
            
        }
    })
    .then(res => {
        console.log("[{0}:fnName():endpointName] - res:".format(this._componentName), res);
        if (fnOnComplete) { fnOnComplete(res.data.DTO); }
    })
    .catch(err => {
        this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
        if (fnOnError) { fnOnError(); }
    });


    Sample POST
    =================
    this.webServices.Post("/capp/savePracticePoints", this._pointsDTO)
        .then(res => {
            console.log("[{0}:savePracticePoints()] - res:".format(this._componentName), res);

            if (res.Success) {

                //Update the alerts
                this.growlBox.addGrowl("success", "Save complete");

                this.markGridAsLoading(false);
                    
            }
            else {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                this.markGridAsLoading(false);
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            this.markGridAsLoading(false);
        })   

*/








